export class ReviewTracking {
  reviewTrackingId: string;
  assignmentId: string;
  caseId: string;
  userId: string;
  partId: string;
  contentTypeCode: string;
}
